module.exports = __webpack_public_path__ + "img/se4.b2c70e5b.jpg";